import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as actionsCreators from "actions/ticket";
import PageBox from "components/public/userIndex";
// import { Link } from "react-router-dom";
import { Row, Col, Breadcrumb, Divider, Button, Modal, Form } from "antd";
import UserPub from "../public";
import UserLeft from "../left";
import FUNC from "common/public";
import TicketManage from "./ticketManage";

const { confirm } = Modal;
class HotNews extends Component {
  formRef = React.createRef();
  constructor() {
    super();
    this.state = {
      visible: false,
      ticket: null
    };
    this.del = this.del.bind(this);
    this.add = this.add.bind(this);
    this.edit = this.edit.bind(this);
    this.handleOk = this.handleOk.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.onFinish = this.onFinish.bind(this);
  }

  add() {
    this.setState({
      visible: true,
      ticket: null
    });
  }

  edit(data) {
    this.setState({
      visible: true,
      ticket: data
    });
  }

  handleCancel() {
    this.setState({ visible: false });
  }

  handleOk() {
    this.formRef.current.submit();
  }

  onFinish(values) {
    let obj={...values,ticket_uid:localStorage.getItem("uid")}
    if(this.state.ticket){
      obj['ticket_id']=this.state.ticket.ticket_id;
    }
    this.props.save(obj)
    this.setState({ visible: false,ticket:null });
  }

  del(item) {
    let that = this;
    confirm({
      title: "确认删除?",
      content: "本次删除无法撤销",
      onOk() {
        that.props.del(item);
      }
    });
  }
  componentDidMount() {
    let uid = localStorage.getItem("uid");
    this.props.lst({ uid: uid });
  }

  render() {
    let { ticketLst } = this.props.ticket;

    return (
      <PageBox>
        <Breadcrumb style={{ paddingTop: 20 }}>
          <Breadcrumb.Item>
            <a href="/">首页</a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <a href="/member">会员中心</a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>我的发票信息</Breadcrumb.Item>
        </Breadcrumb>
        <div className="user-center">
          <div className="user-public">
            <UserPub />
          </div>
          <div className="user-left">
            <UserLeft path={this.props.history.location.pathname} />
          </div>
          <div className="user-right">
            <div className="main">
              <div style={{ textAlign: "right", paddingBottom: 15 }}>
                <Button type="primary" size="small" onClick={this.add}>
                  添加发票信息
                </Button>
              </div>
              {ticketLst ? (
                <div className="lst">
                  <ul>
                    {ticketLst.map(item => (
                      <li key={item.ticket_id}>
                        <div>
                          {item.ticket_detail}
                          <Divider type="vertical" />
                          {item.ticket_company}
                          <Divider type="vertical" />
                          {item.ticket_tel}
                          <Divider type="vertical" />
                          {item.ticket_tax}
                        </div>
                        <div className="btnGroup">
                          <Divider type="vertical" />
                          <Button type="link" onClick={() => this.edit(item)}>
                            编辑
                          </Button>
                          <Divider type="vertical" />
                          <Button
                            type="link"
                            onClick={() => {
                              this.del(item);
                            }}
                          >
                            删除
                          </Button>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              ) : (
                  <div className="empty">
                    <div>没有记录</div>
                  </div>
                )}
            </div>
          </div>
        </div>
        <Modal
          title="发票管理"
          destroyOnClose={true}
          width="360px"
          visible={this.state.visible}
          cancelText="取消"
          okText="保存"
          onOk={this.handleOk}
          onCancel={this.handleCancel}
        >
          <Form
            name="ticket"
            ref={this.formRef}
            initialValues={this.state.ticket}
            layout="vertical"
            style={{ width: "100%" }}
            onFinish={this.onFinish}
          >
            <TicketManage />
          </Form>
        </Modal>
      </PageBox>
    );
  }
}

export default connect(
  state => state,
  dispatch => bindActionCreators(actionsCreators, dispatch)
)(HotNews);
